// @ts-strict-ignore
import NextImage, { ImageProps as NextImageProps } from 'next/image'

import { toBase64 } from '@/shared/lib/utils/common/toBase64'

import styles from './Image.module.scss'

export type ImageProps = {
	alt: string
	priority?: boolean
} & NextImageProps

const getShimmer = (w, h) => `
<svg width="${w}" height="${h}" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
  <defs>
    <linearGradient id="g">
      <stop stopColor="#efefef" offset="5%" />
      <stop stopColor="#f2f2f2" offset="5%" />
      <stop stopColor="#efefef" offset="5%" />
    </linearGradient>
  </defs>
  <rect width="${w}" height="${h}" fill="#f2f2f2" />
  <rect id="r" width="${w / 4}" height="${h}" fill="url(#g)" />
  <animate xlink:href="#r" attributeName="x" from="-${w}" to="${w}" dur="1s" repeatCount="indefinite"  />
</svg>`

export const Image = (props): JSX.Element => {
	// Определяем базовые стили
	const baseStyle: React.CSSProperties = {
		objectFit: 'contain',
		...props.style
	}

	// Если указан только width, добавляем height: "auto"
	// Если указан только height, добавляем width: "auto"
	if (props.width && !props.height && !props.fill) {
		baseStyle.height = 'auto'
	} else if (props.height && !props.width && !props.fill) {
		baseStyle.width = 'auto'
	}

	let updatedProps: ImageProps = {
		quality: 80,
		...props,
		style: baseStyle
		// placeholder: `empty`,
	}

	if (!updatedProps.src) {
		updatedProps = {
			...props,
			src: `/product-image-placeholder.jpeg`
		}
	}

	if (props.placeholder === `blur`) {
		updatedProps = {
			blurDataURL: `data:image/svg+xml;base64,${toBase64(getShimmer(props.width, props.height))}`,
			...updatedProps
		}
	}

	const wrapperStyle: React.CSSProperties = {}

	// Если используется fill, wrapper должен иметь полные размеры и position: relative
	if (props.fill) {
		wrapperStyle.width = '100%'
		wrapperStyle.height = '100%'
		wrapperStyle.position = 'relative'
	}
	// Если указан только width (без height и fill), устанавливаем width и height: auto
	else if (props.width && !props.height) {
		wrapperStyle.maxWidth = props.width
		wrapperStyle.height = 'auto'
	}
	// Если указан только height (без width и fill), устанавливаем height и width: auto
	else if (props.height && !props.width) {
		wrapperStyle.maxHeight = props.height
		wrapperStyle.width = 'auto'
	}
	// Если указаны оба, устанавливаем оба
	else {
		if (props.width) wrapperStyle.maxWidth = props.width
		if (props.height) wrapperStyle.maxHeight = props.height
	}

	return (
		<div className={styles.image} style={wrapperStyle}>
			<NextImage {...updatedProps} />
		</div>
	)
}
